import Modal from 'utils/packages/Modal';
import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import useRequiredBenefitCallback from 'features/premium/hooks/useRequiredBenefitCallback';
import { useMainStackNavigation, } from 'utils/types/navigationV6';
import JoinSpaceModalContent from '../components/JoinSpaceModalContent';
import { useJoinSpace } from '.';
export const useJoinSpaceModal = () => {
    const navigation = useMainStackNavigation();
    const join = useJoinSpace(false);
    const onJoinSpace = useCallback(() => {
        const navigationProps = {
            title: 'Enter the space code',
            onBackPress: (navigation) => navigation.pop(),
            placeholder: 'Space code',
            buttonTitle: 'Continue',
            textFieldProps: {
                maxLength: 8,
            },
            onPressNext: join,
        };
        navigation.navigateDeprecated('TextFieldPage', navigationProps);
    }, [join]);
    const onCreateSpace = useRequiredBenefitCallback(useCallback(() => {
        navigation.navigateDeprecated('CreateSpaceName');
    }, []), 'spaces');
    const show = useCallback(() => Modal.show(<JoinSpaceModalContent onJoinSpace={onJoinSpace} onCreateSpace={onCreateSpace}/>, {
        containerStyle: styles.modal,
        title: 'Join a space',
        lightBg: true,
    }), [onJoinSpace, onCreateSpace]);
    return show;
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
